import { Option, TeacherOption } from '../../generated'
import { isJa } from '../i18n/useLang'

// todo id の型を変更
export function getName(items: Option[], id: number, defaultValue?: string, isOther?: boolean) {
  const found = items.find((i) => i.id === id)
  if (found === undefined || isOther) return defaultValue
  return isJa() ? found.nameJa : found.name
}

export function getTeacherName(
  items: TeacherOption[],
  id: number,
  defaultValue?: string,
  isOther?: boolean
) {
  const found = items.find((i) => i.id === id)
  if (found === undefined || isOther) return defaultValue
  return found.name
}
